import Page from '@/components/Page';

import ClientSessionsTable from './ClientSessionsTable';

const ClientSessionsPage = () => {
  return (
    <Page size="full" title="Client Sessions (fleet)">
      <ClientSessionsTable />
    </Page>
  );
};

export default ClientSessionsPage;
